module.exports = __webpack_public_path__ + "assets/img/主席致辞@2x (3).56f18db8.png";